/**
 * Toggle Switch (piece 3): a native checkbox with role switch, and a mandatory
 * text label to its right reading On or Off, because track colour alone is not
 * an accessible signal. A caller may supply a more specific pair; no label is
 * not a valid construction state.
 */
export interface ToggleLabelPair {
  on: string;
  off: string;
}

export function assertLabelPair(pair: ToggleLabelPair | undefined): ToggleLabelPair {
  if (!pair || !pair.on.trim() || !pair.off.trim()) {
    throw new Error('Toggle Switch renders a mandatory On/Off label pair; no label is not a valid state (piece 3)');
  }
  return pair;
}

export function toggleLabel(pair: ToggleLabelPair, checked: boolean): string {
  return checked ? pair.on : pair.off;
}
